import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
};

export type CreateUpdateInvoiceInput = {
  additionalCost?: InputMaybe<Scalars['Int']['input']>;
  bookerName: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  customerSignatureName: Scalars['String']['input'];
  invoiceDate: Scalars['String']['input'];
  items: Array<CreateUpdateInvoiceItemInput>;
  paymentDetailId?: InputMaybe<Scalars['ID']['input']>;
  paymentType: PaymentType;
  refNo?: InputMaybe<Scalars['String']['input']>;
  signatureBackgroundId?: InputMaybe<Scalars['ID']['input']>;
  signatureId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateUpdateInvoiceItemInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  itemName: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  qty: Scalars['Int']['input'];
};

export type CreateUpdatePaymentDetailInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  bankNo?: InputMaybe<Scalars['String']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  enable: Scalars['Boolean']['input'];
  swiftCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUpdateQuotationInput = {
  additionalCost?: InputMaybe<Scalars['Int']['input']>;
  bookingCode: Scalars['String']['input'];
  confirmedAt?: InputMaybe<Scalars['String']['input']>;
  items: Array<InputMaybe<CreateUpdateQuotationItemInput>>;
  itinerary: Scalars['String']['input'];
  itineraryDate: Scalars['String']['input'];
  signatureBackgroundId?: InputMaybe<Scalars['ID']['input']>;
  signatureId?: InputMaybe<Scalars['ID']['input']>;
  to: Scalars['String']['input'];
};

export type CreateUpdateQuotationItemFlightInput = {
  arrivalTime: Scalars['String']['input'];
  departTime: Scalars['String']['input'];
  flightNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  travel: Scalars['String']['input'];
};

export type CreateUpdateQuotationItemInput = {
  airline: Scalars['String']['input'];
  class: Scalars['String']['input'];
  flights: Array<InputMaybe<CreateUpdateQuotationItemFlightInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  numberOfPax: Scalars['Int']['input'];
  passengers: Array<InputMaybe<Scalars['String']['input']>>;
  pricePerPax: Scalars['Int']['input'];
};

export type CreateUpdateSignatureBackgroundInput = {
  enable: Scalars['Boolean']['input'];
  image: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateUpdateSignatureInput = {
  enable: Scalars['Boolean']['input'];
  image: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DateRangeInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type GenericResponse = {
  __typename?: 'GenericResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  additionalCost?: Maybe<Scalars['Int']['output']>;
  bookerName: Scalars['String']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  customerSignatureName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['String']['output'];
  invoiceItems: Array<InvoiceItem>;
  invoiceNumber: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['String']['output']>;
  paymentDetail?: Maybe<PaymentDetail>;
  paymentDetailId?: Maybe<Scalars['ID']['output']>;
  paymentType: PaymentType;
  refNo?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Signature>;
  signatureBackground?: Maybe<SignatureBackground>;
  signatureBackgroundId?: Maybe<Scalars['ID']['output']>;
  signatureId?: Maybe<Scalars['ID']['output']>;
  status: InvoiceStatus;
  subTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  id: Scalars['ID']['output'];
  invoiceId: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  qty: Scalars['Int']['output'];
};

/** A paginated list of Invoice items. */
export type InvoicePaginator = {
  __typename?: 'InvoicePaginator';
  /** A list of Invoice items. */
  data: Array<Invoice>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum InvoiceStatus {
  Canceled = 'CANCELED',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type ListInvoicesInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatus>;
};

export type ListQuotationsInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QuotationStatus>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelInvoice: Invoice;
  cancelQuotation: Quotation;
  confirmQuotation: Quotation;
  createInvoice: Invoice;
  createPaymentDetail?: Maybe<PaymentDetail>;
  createQuotation: Quotation;
  createSignature?: Maybe<Signature>;
  createSignatureBackground?: Maybe<SignatureBackground>;
  deletePaymentDetail?: Maybe<PaymentDetail>;
  deleteSignature?: Maybe<Signature>;
  deleteSignatureBackground?: Maybe<SignatureBackground>;
  /** login user */
  login: User;
  /** logout from the current session, and showing the user one last time */
  logout?: Maybe<User>;
  payInvoice: Invoice;
  saveSettings: GenericResponse;
  setDefaultPaymentDetail?: Maybe<PaymentDetail>;
  setDefaultSignature?: Maybe<Signature>;
  setDefaultSignatureBackground?: Maybe<SignatureBackground>;
  updateInvoice: Invoice;
  updatePassword?: Maybe<User>;
  updatePaymentDetail?: Maybe<PaymentDetail>;
  updateProfile?: Maybe<User>;
  updateQuotation: Quotation;
  updateSignature?: Maybe<Signature>;
  updateSignatureBackground?: Maybe<SignatureBackground>;
};


export type MutationCancelInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelQuotationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmQuotationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateInvoiceArgs = {
  input: CreateUpdateInvoiceInput;
};


export type MutationCreatePaymentDetailArgs = {
  input: CreateUpdatePaymentDetailInput;
};


export type MutationCreateQuotationArgs = {
  input: CreateUpdateQuotationInput;
};


export type MutationCreateSignatureArgs = {
  input: CreateUpdateSignatureInput;
};


export type MutationCreateSignatureBackgroundArgs = {
  input: CreateUpdateSignatureBackgroundInput;
};


export type MutationDeletePaymentDetailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSignatureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSignatureBackgroundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationPayInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: PayInvoiceInput;
};


export type MutationSaveSettingsArgs = {
  input: SaveSettingsInput;
};


export type MutationSetDefaultPaymentDetailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetDefaultSignatureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetDefaultSignatureBackgroundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: CreateUpdateInvoiceInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePaymentDetailArgs = {
  id: Scalars['ID']['input'];
  input: CreateUpdatePaymentDetailInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateQuotationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  input: CreateUpdateQuotationInput;
};


export type MutationUpdateSignatureArgs = {
  id: Scalars['ID']['input'];
  input: CreateUpdateSignatureInput;
};


export type MutationUpdateSignatureBackgroundArgs = {
  id: Scalars['ID']['input'];
  input: CreateUpdateSignatureBackgroundInput;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type PayInvoiceInput = {
  paidAt: Scalars['String']['input'];
};

export type PaymentDetail = {
  __typename?: 'PaymentDetail';
  accountNo: Scalars['String']['output'];
  bankNo: Scalars['String']['output'];
  branchName: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  enable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  swiftCode: Scalars['String']['output'];
};

/** A paginated list of PaymentDetail items. */
export type PaymentDetailPaginator = {
  __typename?: 'PaymentDetailPaginator';
  /** A list of PaymentDetail items. */
  data: Array<PaymentDetail>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum PaymentType {
  Cash = 'CASH',
  Credit = 'CREDIT'
}

export type Query = {
  __typename?: 'Query';
  allGroupSettings: Array<Setting>;
  getInvoice?: Maybe<Invoice>;
  getPaymentDetail?: Maybe<PaymentDetail>;
  getQuotation?: Maybe<Quotation>;
  getSignature: Signature;
  getSignatureBackground: SignatureBackground;
  getUser?: Maybe<User>;
  listInvoices: InvoicePaginator;
  listPaymentDetails: PaymentDetailPaginator;
  listQuotations: QuotationPaginator;
  listSignatureBackgrounds: SignatureBackgroundPaginator;
  listSignatures: SignaturePaginator;
  listUsers: UserPaginator;
  /** details of currently logged in user */
  me?: Maybe<User>;
};


export type QueryAllGroupSettingsArgs = {
  group: SetttingGroup;
};


export type QueryGetInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPaymentDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuotationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSignatureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSignatureBackgroundArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListInvoicesArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ListInvoicesInput>;
};


export type QueryListPaymentDetailsArgs = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListQuotationsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ListQuotationsInput>;
};


export type QueryListSignatureBackgroundsArgs = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListSignaturesArgs = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  first: Scalars['Int']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListUsersArgs = {
  first: Scalars['Int']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type Quotation = {
  __typename?: 'Quotation';
  additionalCost?: Maybe<Scalars['Int']['output']>;
  bookingCode: Scalars['String']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itinerary: Scalars['String']['output'];
  itineraryDate: Scalars['String']['output'];
  quotationItems: Array<QuotationItem>;
  signature?: Maybe<Signature>;
  signatureBackground?: Maybe<SignatureBackground>;
  signatureBackgroundId?: Maybe<Scalars['ID']['output']>;
  signatureId?: Maybe<Scalars['ID']['output']>;
  status: QuotationStatus;
  subTotal: Scalars['Int']['output'];
  to: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type QuotationItem = {
  __typename?: 'QuotationItem';
  airline: Scalars['String']['output'];
  class: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  numberOfPax: Scalars['Int']['output'];
  passengers: Array<Maybe<Scalars['String']['output']>>;
  pricePerPax: Scalars['Int']['output'];
  quotationItemFlights: Array<QuotationItemFlight>;
};

export type QuotationItemFlight = {
  __typename?: 'QuotationItemFlight';
  arrivalTime: Scalars['String']['output'];
  departTime: Scalars['String']['output'];
  flightNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  travel: Scalars['String']['output'];
};

/** A paginated list of Quotation items. */
export type QuotationPaginator = {
  __typename?: 'QuotationPaginator';
  /** A list of Quotation items. */
  data: Array<Quotation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum QuotationStatus {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Hold = 'HOLD'
}

export type SaveSettingsInput = {
  group: Scalars['String']['input'];
  settings: Array<SettingKeyValueInput>;
};

export type Setting = {
  __typename?: 'Setting';
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
  valueImage?: Maybe<Scalars['String']['output']>;
};

export type SettingKeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum SetttingGroup {
  InvoiceSetting = 'INVOICE_SETTING',
  QuotationSetting = 'QUOTATION_SETTING'
}

export type Signature = {
  __typename?: 'Signature';
  enable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type SignatureBackground = {
  __typename?: 'SignatureBackground';
  enable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** A paginated list of SignatureBackground items. */
export type SignatureBackgroundPaginator = {
  __typename?: 'SignatureBackgroundPaginator';
  /** A list of SignatureBackground items. */
  data: Array<SignatureBackground>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** A paginated list of Signature items. */
export type SignaturePaginator = {
  __typename?: 'SignaturePaginator';
  /** A list of Signature items. */
  data: Array<Signature>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type UpdatePasswordInput = {
  oldPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UpdateProfileInput = {
  name: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'User', id: string, name: string, email: string, createdAt: any, updatedAt?: any | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'User', id: string } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, name: string, email: string, createdAt: any, updatedAt?: any | null } | null };

export type CorePaginatorInfoFieldsFragment = { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number };

export type CreateInvoiceMutationVariables = Exact<{
  input: CreateUpdateInvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'Invoice', id: string } };

export type UpdateInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CreateUpdateInvoiceInput;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice: { __typename?: 'Invoice', id: string, invoiceNumber: string, invoiceDate: string, customerName: string, bookerName: string, subTotal: number, total: number, status: InvoiceStatus, paymentType: PaymentType, additionalCost?: number | null, signatureId?: string | null, canceledAt?: string | null, paidAt?: string | null, paymentDetail?: { __typename?: 'PaymentDetail', id: string, companyName: string, branchName: string, bankNo: string, swiftCode: string, accountNo: string } | null, invoiceItems: Array<{ __typename?: 'InvoiceItem', id: string, itemName: string, price: number, qty: number }> } };

export type CancelInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelInvoiceMutation = { __typename?: 'Mutation', cancelInvoice: { __typename?: 'Invoice', id: string, status: InvoiceStatus, canceledAt?: string | null } };

export type PayInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PayInvoiceInput;
}>;


export type PayInvoiceMutation = { __typename?: 'Mutation', payInvoice: { __typename?: 'Invoice', id: string, status: InvoiceStatus, paidAt?: string | null } };

export type ListInvoicesQueryVariables = Exact<{
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ListInvoicesInput>;
}>;


export type ListInvoicesQuery = { __typename?: 'Query', listInvoices: { __typename?: 'InvoicePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Invoice', id: string, invoiceNumber: string, refNo?: string | null, invoiceDate: string, customerName: string, customerSignatureName: string, paymentType: PaymentType, additionalCost?: number | null, status: InvoiceStatus, subTotal: number, total: number }> } };

export type GetInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', getInvoice?: { __typename?: 'Invoice', id: string, invoiceNumber: string, refNo?: string | null, invoiceDate: string, customerName: string, customerSignatureName: string, bookerName: string, subTotal: number, total: number, status: InvoiceStatus, paymentType: PaymentType, additionalCost?: number | null, paymentDetailId?: string | null, signatureId?: string | null, signatureBackgroundId?: string | null, canceledAt?: string | null, paidAt?: string | null, paymentDetail?: { __typename?: 'PaymentDetail', id: string, companyName: string, branchName: string, bankNo: string, swiftCode: string, accountNo: string } | null, signature?: { __typename?: 'Signature', id: string, name: string, image: string, imageUrl: string } | null, signatureBackground?: { __typename?: 'SignatureBackground', id: string, name: string, image: string, imageUrl: string } | null, invoiceItems: Array<{ __typename?: 'InvoiceItem', id: string, itemName: string, price: number, qty: number }> } | null };

export type CreatePaymentDetailMutationVariables = Exact<{
  input: CreateUpdatePaymentDetailInput;
}>;


export type CreatePaymentDetailMutation = { __typename?: 'Mutation', createPaymentDetail?: { __typename?: 'PaymentDetail', id: string } | null };

export type UpdatePaymentDetailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CreateUpdatePaymentDetailInput;
}>;


export type UpdatePaymentDetailMutation = { __typename?: 'Mutation', updatePaymentDetail?: { __typename?: 'PaymentDetail', id: string, companyName: string, branchName: string, bankNo: string, swiftCode: string, accountNo: string, enable: boolean } | null };

export type SetDefaultPaymentDetailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetDefaultPaymentDetailMutation = { __typename?: 'Mutation', setDefaultPaymentDetail?: { __typename?: 'PaymentDetail', id: string, isDefault: boolean } | null };

export type DeletePaymentDetailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePaymentDetailMutation = { __typename?: 'Mutation', deletePaymentDetail?: { __typename?: 'PaymentDetail', id: string } | null };

export type ListPaymentDetailsQueryVariables = Exact<{
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListPaymentDetailsQuery = { __typename?: 'Query', listPaymentDetails: { __typename?: 'PaymentDetailPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'PaymentDetail', id: string, companyName: string, branchName: string, bankNo: string, swiftCode: string, accountNo: string, isDefault: boolean, enable: boolean }> } };

export type GetPaymentDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPaymentDetailQuery = { __typename?: 'Query', getPaymentDetail?: { __typename?: 'PaymentDetail', id: string, companyName: string, branchName: string, bankNo: string, swiftCode: string, accountNo: string, enable: boolean } | null };

export type CreateQuotationMutationVariables = Exact<{
  input: CreateUpdateQuotationInput;
}>;


export type CreateQuotationMutation = { __typename?: 'Mutation', createQuotation: { __typename?: 'Quotation', id: string } };

export type UpdateQuotationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: CreateUpdateQuotationInput;
}>;


export type UpdateQuotationMutation = { __typename?: 'Mutation', updateQuotation: { __typename?: 'Quotation', id: string, itinerary: string, to: string, itineraryDate: string, confirmedAt?: string | null, bookingCode: string, additionalCost?: number | null, signatureId?: string | null, status: QuotationStatus, subTotal: number, total: number, quotationItems: Array<{ __typename?: 'QuotationItem', id: string, numberOfPax: number, pricePerPax: number, airline: string, class: string, passengers: Array<string | null>, quotationItemFlights: Array<{ __typename?: 'QuotationItemFlight', id: string, flightNumber: string, travel: string, departTime: string, arrivalTime: string }> }> } };

export type CancelQuotationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelQuotationMutation = { __typename?: 'Mutation', cancelQuotation: { __typename?: 'Quotation', id: string, status: QuotationStatus, canceledAt?: string | null } };

export type ConfirmQuotationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConfirmQuotationMutation = { __typename?: 'Mutation', confirmQuotation: { __typename?: 'Quotation', id: string, status: QuotationStatus, confirmedAt?: string | null } };

export type ListQuotationsQueryVariables = Exact<{
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<ListQuotationsInput>;
}>;


export type ListQuotationsQuery = { __typename?: 'Query', listQuotations: { __typename?: 'QuotationPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Quotation', id: string, itinerary: string, to: string, itineraryDate: string, status: QuotationStatus, confirmedAt?: string | null, bookingCode: string, subTotal: number, additionalCost?: number | null, total: number }> } };

export type GetQuotationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetQuotationQuery = { __typename?: 'Query', getQuotation?: { __typename?: 'Quotation', id: string, itinerary: string, to: string, itineraryDate: string, confirmedAt?: string | null, bookingCode: string, additionalCost?: number | null, signatureId?: string | null, signatureBackgroundId?: string | null, status: QuotationStatus, subTotal: number, total: number, signature?: { __typename?: 'Signature', id: string, name: string, image: string, imageUrl: string } | null, signatureBackground?: { __typename?: 'SignatureBackground', id: string, name: string, image: string, imageUrl: string } | null, quotationItems: Array<{ __typename?: 'QuotationItem', id: string, numberOfPax: number, pricePerPax: number, airline: string, class: string, passengers: Array<string | null>, quotationItemFlights: Array<{ __typename?: 'QuotationItemFlight', id: string, flightNumber: string, travel: string, departTime: string, arrivalTime: string }> }> } | null };

export type SaveSettingsMutationVariables = Exact<{
  input: SaveSettingsInput;
}>;


export type SaveSettingsMutation = { __typename?: 'Mutation', saveSettings: { __typename?: 'GenericResponse', success: boolean } };

export type AllGroupSettingsQueryVariables = Exact<{
  group: SetttingGroup;
}>;


export type AllGroupSettingsQuery = { __typename?: 'Query', allGroupSettings: Array<{ __typename?: 'Setting', id: string, group: string, key: string, value: string, valueImage?: string | null }> };

export type CreateSignatureMutationVariables = Exact<{
  input: CreateUpdateSignatureInput;
}>;


export type CreateSignatureMutation = { __typename?: 'Mutation', createSignature?: { __typename?: 'Signature', id: string } | null };

export type UpdateSignatureMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CreateUpdateSignatureInput;
}>;


export type UpdateSignatureMutation = { __typename?: 'Mutation', updateSignature?: { __typename?: 'Signature', id: string, image: string, imageUrl: string, name: string, enable: boolean } | null };

export type SetDefaultSignatureMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetDefaultSignatureMutation = { __typename?: 'Mutation', setDefaultSignature?: { __typename?: 'Signature', id: string, isDefault: boolean } | null };

export type DeleteSignatureMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSignatureMutation = { __typename?: 'Mutation', deleteSignature?: { __typename?: 'Signature', id: string } | null };

export type ListSignaturesQueryVariables = Exact<{
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListSignaturesQuery = { __typename?: 'Query', listSignatures: { __typename?: 'SignaturePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Signature', id: string, image: string, imageUrl: string, name: string, isDefault: boolean, enable: boolean }> } };

export type GetSignatureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSignatureQuery = { __typename?: 'Query', getSignature: { __typename?: 'Signature', id: string, image: string, imageUrl: string, name: string, enable: boolean } };

export type CreateSignatureBackgroundMutationVariables = Exact<{
  input: CreateUpdateSignatureBackgroundInput;
}>;


export type CreateSignatureBackgroundMutation = { __typename?: 'Mutation', createSignatureBackground?: { __typename?: 'SignatureBackground', id: string } | null };

export type UpdateSignatureBackgroundMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CreateUpdateSignatureBackgroundInput;
}>;


export type UpdateSignatureBackgroundMutation = { __typename?: 'Mutation', updateSignatureBackground?: { __typename?: 'SignatureBackground', id: string, image: string, imageUrl: string, name: string, enable: boolean } | null };

export type SetDefaultSignatureBackgroundMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetDefaultSignatureBackgroundMutation = { __typename?: 'Mutation', setDefaultSignatureBackground?: { __typename?: 'SignatureBackground', id: string, isDefault: boolean } | null };

export type DeleteSignatureBackgroundMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSignatureBackgroundMutation = { __typename?: 'Mutation', deleteSignatureBackground?: { __typename?: 'SignatureBackground', id: string } | null };

export type ListSignatureBackgroundsQueryVariables = Exact<{
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListSignatureBackgroundsQuery = { __typename?: 'Query', listSignatureBackgrounds: { __typename?: 'SignatureBackgroundPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'SignatureBackground', id: string, image: string, imageUrl: string, name: string, isDefault: boolean, enable: boolean }> } };

export type GetSignatureBackgroundQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSignatureBackgroundQuery = { __typename?: 'Query', getSignatureBackground: { __typename?: 'SignatureBackground', id: string, image: string, imageUrl: string, name: string, enable: boolean } };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id: string } | null };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword?: { __typename?: 'User', id: string } | null };

export type ListUsersQueryVariables = Exact<{
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers: { __typename?: 'UserPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'User', id: string, name: string, email: string }> } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', id: string, name: string, email: string } | null };

export const CorePaginatorInfoFieldsFragmentDoc = gql`
    fragment CorePaginatorInfoFields on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    id
    name
    email
    createdAt
    updatedAt
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    id
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    name
    email
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($input: CreateUpdateInvoiceInput!) {
  createInvoice(input: $input) {
    id
  }
}
    `;
export type CreateInvoiceMutationFn = Apollo.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, options);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($id: ID!, $input: CreateUpdateInvoiceInput!) {
  updateInvoice(id: $id, input: $input) {
    id
    invoiceNumber
    invoiceDate
    customerName
    bookerName
    subTotal
    total
    status
    paymentType
    additionalCost
    paymentDetail {
      id
      companyName
      branchName
      bankNo
      swiftCode
      accountNo
    }
    signatureId
    canceledAt
    paidAt
    invoiceItems {
      id
      itemName
      price
      qty
    }
  }
}
    `;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const CancelInvoiceDocument = gql`
    mutation CancelInvoice($id: ID!) {
  cancelInvoice(id: $id) {
    id
    status
    canceledAt
  }
}
    `;
export type CancelInvoiceMutationFn = Apollo.MutationFunction<CancelInvoiceMutation, CancelInvoiceMutationVariables>;

/**
 * __useCancelInvoiceMutation__
 *
 * To run a mutation, you first call `useCancelInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInvoiceMutation, { data, loading, error }] = useCancelInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CancelInvoiceMutation, CancelInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelInvoiceMutation, CancelInvoiceMutationVariables>(CancelInvoiceDocument, options);
      }
export type CancelInvoiceMutationHookResult = ReturnType<typeof useCancelInvoiceMutation>;
export type CancelInvoiceMutationResult = Apollo.MutationResult<CancelInvoiceMutation>;
export type CancelInvoiceMutationOptions = Apollo.BaseMutationOptions<CancelInvoiceMutation, CancelInvoiceMutationVariables>;
export const PayInvoiceDocument = gql`
    mutation PayInvoice($id: ID!, $input: PayInvoiceInput!) {
  payInvoice(id: $id, input: $input) {
    id
    status
    paidAt
  }
}
    `;
export type PayInvoiceMutationFn = Apollo.MutationFunction<PayInvoiceMutation, PayInvoiceMutationVariables>;

/**
 * __usePayInvoiceMutation__
 *
 * To run a mutation, you first call `usePayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payInvoiceMutation, { data, loading, error }] = usePayInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<PayInvoiceMutation, PayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayInvoiceMutation, PayInvoiceMutationVariables>(PayInvoiceDocument, options);
      }
export type PayInvoiceMutationHookResult = ReturnType<typeof usePayInvoiceMutation>;
export type PayInvoiceMutationResult = Apollo.MutationResult<PayInvoiceMutation>;
export type PayInvoiceMutationOptions = Apollo.BaseMutationOptions<PayInvoiceMutation, PayInvoiceMutationVariables>;
export const ListInvoicesDocument = gql`
    query ListInvoices($first: Int! = 10, $page: Int, $params: ListInvoicesInput) {
  listInvoices(first: $first, page: $page, params: $params) {
    paginatorInfo {
      ...CorePaginatorInfoFields
    }
    data {
      id
      invoiceNumber
      refNo
      invoiceDate
      customerName
      customerSignatureName
      paymentType
      additionalCost
      status
      subTotal
      total
    }
  }
}
    ${CorePaginatorInfoFieldsFragmentDoc}`;

/**
 * __useListInvoicesQuery__
 *
 * To run a query within a React component, call `useListInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInvoicesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useListInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<ListInvoicesQuery, ListInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInvoicesQuery, ListInvoicesQueryVariables>(ListInvoicesDocument, options);
      }
export function useListInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInvoicesQuery, ListInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInvoicesQuery, ListInvoicesQueryVariables>(ListInvoicesDocument, options);
        }
export function useListInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInvoicesQuery, ListInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInvoicesQuery, ListInvoicesQueryVariables>(ListInvoicesDocument, options);
        }
export type ListInvoicesQueryHookResult = ReturnType<typeof useListInvoicesQuery>;
export type ListInvoicesLazyQueryHookResult = ReturnType<typeof useListInvoicesLazyQuery>;
export type ListInvoicesSuspenseQueryHookResult = ReturnType<typeof useListInvoicesSuspenseQuery>;
export type ListInvoicesQueryResult = Apollo.QueryResult<ListInvoicesQuery, ListInvoicesQueryVariables>;
export const GetInvoiceDocument = gql`
    query GetInvoice($id: ID!) {
  getInvoice(id: $id) {
    id
    invoiceNumber
    refNo
    invoiceDate
    customerName
    customerSignatureName
    bookerName
    subTotal
    total
    status
    paymentType
    additionalCost
    paymentDetailId
    paymentDetail {
      id
      companyName
      branchName
      bankNo
      swiftCode
      accountNo
    }
    signatureId
    signature {
      id
      name
      image
      imageUrl
    }
    signatureBackgroundId
    signatureBackground {
      id
      name
      image
      imageUrl
    }
    canceledAt
    paidAt
    invoiceItems {
      id
      itemName
      price
      qty
    }
  }
}
    `;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a React component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables> & ({ variables: GetInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
      }
export function useGetInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export function useGetInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export type GetInvoiceQueryHookResult = ReturnType<typeof useGetInvoiceQuery>;
export type GetInvoiceLazyQueryHookResult = ReturnType<typeof useGetInvoiceLazyQuery>;
export type GetInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceSuspenseQuery>;
export type GetInvoiceQueryResult = Apollo.QueryResult<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const CreatePaymentDetailDocument = gql`
    mutation CreatePaymentDetail($input: CreateUpdatePaymentDetailInput!) {
  createPaymentDetail(input: $input) {
    id
  }
}
    `;
export type CreatePaymentDetailMutationFn = Apollo.MutationFunction<CreatePaymentDetailMutation, CreatePaymentDetailMutationVariables>;

/**
 * __useCreatePaymentDetailMutation__
 *
 * To run a mutation, you first call `useCreatePaymentDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentDetailMutation, { data, loading, error }] = useCreatePaymentDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentDetailMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentDetailMutation, CreatePaymentDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentDetailMutation, CreatePaymentDetailMutationVariables>(CreatePaymentDetailDocument, options);
      }
export type CreatePaymentDetailMutationHookResult = ReturnType<typeof useCreatePaymentDetailMutation>;
export type CreatePaymentDetailMutationResult = Apollo.MutationResult<CreatePaymentDetailMutation>;
export type CreatePaymentDetailMutationOptions = Apollo.BaseMutationOptions<CreatePaymentDetailMutation, CreatePaymentDetailMutationVariables>;
export const UpdatePaymentDetailDocument = gql`
    mutation UpdatePaymentDetail($id: ID!, $input: CreateUpdatePaymentDetailInput!) {
  updatePaymentDetail(id: $id, input: $input) {
    id
    companyName
    branchName
    bankNo
    swiftCode
    accountNo
    enable
  }
}
    `;
export type UpdatePaymentDetailMutationFn = Apollo.MutationFunction<UpdatePaymentDetailMutation, UpdatePaymentDetailMutationVariables>;

/**
 * __useUpdatePaymentDetailMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentDetailMutation, { data, loading, error }] = useUpdatePaymentDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentDetailMutation, UpdatePaymentDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentDetailMutation, UpdatePaymentDetailMutationVariables>(UpdatePaymentDetailDocument, options);
      }
export type UpdatePaymentDetailMutationHookResult = ReturnType<typeof useUpdatePaymentDetailMutation>;
export type UpdatePaymentDetailMutationResult = Apollo.MutationResult<UpdatePaymentDetailMutation>;
export type UpdatePaymentDetailMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentDetailMutation, UpdatePaymentDetailMutationVariables>;
export const SetDefaultPaymentDetailDocument = gql`
    mutation SetDefaultPaymentDetail($id: ID!) {
  setDefaultPaymentDetail(id: $id) {
    id
    isDefault
  }
}
    `;
export type SetDefaultPaymentDetailMutationFn = Apollo.MutationFunction<SetDefaultPaymentDetailMutation, SetDefaultPaymentDetailMutationVariables>;

/**
 * __useSetDefaultPaymentDetailMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentDetailMutation, { data, loading, error }] = useSetDefaultPaymentDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultPaymentDetailMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentDetailMutation, SetDefaultPaymentDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentDetailMutation, SetDefaultPaymentDetailMutationVariables>(SetDefaultPaymentDetailDocument, options);
      }
export type SetDefaultPaymentDetailMutationHookResult = ReturnType<typeof useSetDefaultPaymentDetailMutation>;
export type SetDefaultPaymentDetailMutationResult = Apollo.MutationResult<SetDefaultPaymentDetailMutation>;
export type SetDefaultPaymentDetailMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentDetailMutation, SetDefaultPaymentDetailMutationVariables>;
export const DeletePaymentDetailDocument = gql`
    mutation DeletePaymentDetail($id: ID!) {
  deletePaymentDetail(id: $id) {
    id
  }
}
    `;
export type DeletePaymentDetailMutationFn = Apollo.MutationFunction<DeletePaymentDetailMutation, DeletePaymentDetailMutationVariables>;

/**
 * __useDeletePaymentDetailMutation__
 *
 * To run a mutation, you first call `useDeletePaymentDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentDetailMutation, { data, loading, error }] = useDeletePaymentDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePaymentDetailMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentDetailMutation, DeletePaymentDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentDetailMutation, DeletePaymentDetailMutationVariables>(DeletePaymentDetailDocument, options);
      }
export type DeletePaymentDetailMutationHookResult = ReturnType<typeof useDeletePaymentDetailMutation>;
export type DeletePaymentDetailMutationResult = Apollo.MutationResult<DeletePaymentDetailMutation>;
export type DeletePaymentDetailMutationOptions = Apollo.BaseMutationOptions<DeletePaymentDetailMutation, DeletePaymentDetailMutationVariables>;
export const ListPaymentDetailsDocument = gql`
    query ListPaymentDetails($first: Int! = 10, $page: Int, $key: String, $enable: Boolean) {
  listPaymentDetails(first: $first, page: $page, key: $key, enable: $enable) {
    paginatorInfo {
      ...CorePaginatorInfoFields
    }
    data {
      id
      companyName
      branchName
      bankNo
      swiftCode
      accountNo
      isDefault
      enable
    }
  }
}
    ${CorePaginatorInfoFieldsFragmentDoc}`;

/**
 * __useListPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useListPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentDetailsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      key: // value for 'key'
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useListPaymentDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ListPaymentDetailsQuery, ListPaymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPaymentDetailsQuery, ListPaymentDetailsQueryVariables>(ListPaymentDetailsDocument, options);
      }
export function useListPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPaymentDetailsQuery, ListPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPaymentDetailsQuery, ListPaymentDetailsQueryVariables>(ListPaymentDetailsDocument, options);
        }
export function useListPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPaymentDetailsQuery, ListPaymentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPaymentDetailsQuery, ListPaymentDetailsQueryVariables>(ListPaymentDetailsDocument, options);
        }
export type ListPaymentDetailsQueryHookResult = ReturnType<typeof useListPaymentDetailsQuery>;
export type ListPaymentDetailsLazyQueryHookResult = ReturnType<typeof useListPaymentDetailsLazyQuery>;
export type ListPaymentDetailsSuspenseQueryHookResult = ReturnType<typeof useListPaymentDetailsSuspenseQuery>;
export type ListPaymentDetailsQueryResult = Apollo.QueryResult<ListPaymentDetailsQuery, ListPaymentDetailsQueryVariables>;
export const GetPaymentDetailDocument = gql`
    query GetPaymentDetail($id: ID!) {
  getPaymentDetail(id: $id) {
    id
    companyName
    branchName
    bankNo
    swiftCode
    accountNo
    enable
  }
}
    `;

/**
 * __useGetPaymentDetailQuery__
 *
 * To run a query within a React component, call `useGetPaymentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentDetailQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentDetailQuery, GetPaymentDetailQueryVariables> & ({ variables: GetPaymentDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentDetailQuery, GetPaymentDetailQueryVariables>(GetPaymentDetailDocument, options);
      }
export function useGetPaymentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentDetailQuery, GetPaymentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentDetailQuery, GetPaymentDetailQueryVariables>(GetPaymentDetailDocument, options);
        }
export function useGetPaymentDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentDetailQuery, GetPaymentDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentDetailQuery, GetPaymentDetailQueryVariables>(GetPaymentDetailDocument, options);
        }
export type GetPaymentDetailQueryHookResult = ReturnType<typeof useGetPaymentDetailQuery>;
export type GetPaymentDetailLazyQueryHookResult = ReturnType<typeof useGetPaymentDetailLazyQuery>;
export type GetPaymentDetailSuspenseQueryHookResult = ReturnType<typeof useGetPaymentDetailSuspenseQuery>;
export type GetPaymentDetailQueryResult = Apollo.QueryResult<GetPaymentDetailQuery, GetPaymentDetailQueryVariables>;
export const CreateQuotationDocument = gql`
    mutation CreateQuotation($input: CreateUpdateQuotationInput!) {
  createQuotation(input: $input) {
    id
  }
}
    `;
export type CreateQuotationMutationFn = Apollo.MutationFunction<CreateQuotationMutation, CreateQuotationMutationVariables>;

/**
 * __useCreateQuotationMutation__
 *
 * To run a mutation, you first call `useCreateQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuotationMutation, { data, loading, error }] = useCreateQuotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuotationMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuotationMutation, CreateQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuotationMutation, CreateQuotationMutationVariables>(CreateQuotationDocument, options);
      }
export type CreateQuotationMutationHookResult = ReturnType<typeof useCreateQuotationMutation>;
export type CreateQuotationMutationResult = Apollo.MutationResult<CreateQuotationMutation>;
export type CreateQuotationMutationOptions = Apollo.BaseMutationOptions<CreateQuotationMutation, CreateQuotationMutationVariables>;
export const UpdateQuotationDocument = gql`
    mutation UpdateQuotation($id: String!, $input: CreateUpdateQuotationInput!) {
  updateQuotation(id: $id, input: $input) {
    id
    itinerary
    to
    itineraryDate
    confirmedAt
    bookingCode
    additionalCost
    signatureId
    status
    subTotal
    total
    quotationItems {
      id
      numberOfPax
      pricePerPax
      airline
      class
      passengers
      quotationItemFlights {
        id
        flightNumber
        travel
        departTime
        arrivalTime
      }
    }
  }
}
    `;
export type UpdateQuotationMutationFn = Apollo.MutationFunction<UpdateQuotationMutation, UpdateQuotationMutationVariables>;

/**
 * __useUpdateQuotationMutation__
 *
 * To run a mutation, you first call `useUpdateQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuotationMutation, { data, loading, error }] = useUpdateQuotationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuotationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuotationMutation, UpdateQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuotationMutation, UpdateQuotationMutationVariables>(UpdateQuotationDocument, options);
      }
export type UpdateQuotationMutationHookResult = ReturnType<typeof useUpdateQuotationMutation>;
export type UpdateQuotationMutationResult = Apollo.MutationResult<UpdateQuotationMutation>;
export type UpdateQuotationMutationOptions = Apollo.BaseMutationOptions<UpdateQuotationMutation, UpdateQuotationMutationVariables>;
export const CancelQuotationDocument = gql`
    mutation CancelQuotation($id: ID!) {
  cancelQuotation(id: $id) {
    id
    status
    canceledAt
  }
}
    `;
export type CancelQuotationMutationFn = Apollo.MutationFunction<CancelQuotationMutation, CancelQuotationMutationVariables>;

/**
 * __useCancelQuotationMutation__
 *
 * To run a mutation, you first call `useCancelQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelQuotationMutation, { data, loading, error }] = useCancelQuotationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelQuotationMutation(baseOptions?: Apollo.MutationHookOptions<CancelQuotationMutation, CancelQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelQuotationMutation, CancelQuotationMutationVariables>(CancelQuotationDocument, options);
      }
export type CancelQuotationMutationHookResult = ReturnType<typeof useCancelQuotationMutation>;
export type CancelQuotationMutationResult = Apollo.MutationResult<CancelQuotationMutation>;
export type CancelQuotationMutationOptions = Apollo.BaseMutationOptions<CancelQuotationMutation, CancelQuotationMutationVariables>;
export const ConfirmQuotationDocument = gql`
    mutation ConfirmQuotation($id: ID!) {
  confirmQuotation(id: $id) {
    id
    status
    confirmedAt
  }
}
    `;
export type ConfirmQuotationMutationFn = Apollo.MutationFunction<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>;

/**
 * __useConfirmQuotationMutation__
 *
 * To run a mutation, you first call `useConfirmQuotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmQuotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmQuotationMutation, { data, loading, error }] = useConfirmQuotationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmQuotationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>(ConfirmQuotationDocument, options);
      }
export type ConfirmQuotationMutationHookResult = ReturnType<typeof useConfirmQuotationMutation>;
export type ConfirmQuotationMutationResult = Apollo.MutationResult<ConfirmQuotationMutation>;
export type ConfirmQuotationMutationOptions = Apollo.BaseMutationOptions<ConfirmQuotationMutation, ConfirmQuotationMutationVariables>;
export const ListQuotationsDocument = gql`
    query ListQuotations($first: Int! = 10, $page: Int, $params: ListQuotationsInput) {
  listQuotations(first: $first, page: $page, params: $params) {
    paginatorInfo {
      ...CorePaginatorInfoFields
    }
    data {
      id
      itinerary
      to
      itineraryDate
      status
      confirmedAt
      bookingCode
      subTotal
      additionalCost
      total
    }
  }
}
    ${CorePaginatorInfoFieldsFragmentDoc}`;

/**
 * __useListQuotationsQuery__
 *
 * To run a query within a React component, call `useListQuotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQuotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListQuotationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useListQuotationsQuery(baseOptions?: Apollo.QueryHookOptions<ListQuotationsQuery, ListQuotationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListQuotationsQuery, ListQuotationsQueryVariables>(ListQuotationsDocument, options);
      }
export function useListQuotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListQuotationsQuery, ListQuotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListQuotationsQuery, ListQuotationsQueryVariables>(ListQuotationsDocument, options);
        }
export function useListQuotationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListQuotationsQuery, ListQuotationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListQuotationsQuery, ListQuotationsQueryVariables>(ListQuotationsDocument, options);
        }
export type ListQuotationsQueryHookResult = ReturnType<typeof useListQuotationsQuery>;
export type ListQuotationsLazyQueryHookResult = ReturnType<typeof useListQuotationsLazyQuery>;
export type ListQuotationsSuspenseQueryHookResult = ReturnType<typeof useListQuotationsSuspenseQuery>;
export type ListQuotationsQueryResult = Apollo.QueryResult<ListQuotationsQuery, ListQuotationsQueryVariables>;
export const GetQuotationDocument = gql`
    query GetQuotation($id: ID!) {
  getQuotation(id: $id) {
    id
    itinerary
    to
    itineraryDate
    confirmedAt
    bookingCode
    additionalCost
    signatureId
    signature {
      id
      name
      image
      imageUrl
    }
    signatureBackgroundId
    signatureBackground {
      id
      name
      image
      imageUrl
    }
    status
    subTotal
    total
    quotationItems {
      id
      numberOfPax
      pricePerPax
      airline
      class
      passengers
      quotationItemFlights {
        id
        flightNumber
        travel
        departTime
        arrivalTime
      }
    }
  }
}
    `;

/**
 * __useGetQuotationQuery__
 *
 * To run a query within a React component, call `useGetQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuotationQuery(baseOptions: Apollo.QueryHookOptions<GetQuotationQuery, GetQuotationQueryVariables> & ({ variables: GetQuotationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotationQuery, GetQuotationQueryVariables>(GetQuotationDocument, options);
      }
export function useGetQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotationQuery, GetQuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotationQuery, GetQuotationQueryVariables>(GetQuotationDocument, options);
        }
export function useGetQuotationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotationQuery, GetQuotationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotationQuery, GetQuotationQueryVariables>(GetQuotationDocument, options);
        }
export type GetQuotationQueryHookResult = ReturnType<typeof useGetQuotationQuery>;
export type GetQuotationLazyQueryHookResult = ReturnType<typeof useGetQuotationLazyQuery>;
export type GetQuotationSuspenseQueryHookResult = ReturnType<typeof useGetQuotationSuspenseQuery>;
export type GetQuotationQueryResult = Apollo.QueryResult<GetQuotationQuery, GetQuotationQueryVariables>;
export const SaveSettingsDocument = gql`
    mutation SaveSettings($input: SaveSettingsInput!) {
  saveSettings(input: $input) {
    success
  }
}
    `;
export type SaveSettingsMutationFn = Apollo.MutationFunction<SaveSettingsMutation, SaveSettingsMutationVariables>;

/**
 * __useSaveSettingsMutation__
 *
 * To run a mutation, you first call `useSaveSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSettingsMutation, { data, loading, error }] = useSaveSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveSettingsMutation, SaveSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSettingsMutation, SaveSettingsMutationVariables>(SaveSettingsDocument, options);
      }
export type SaveSettingsMutationHookResult = ReturnType<typeof useSaveSettingsMutation>;
export type SaveSettingsMutationResult = Apollo.MutationResult<SaveSettingsMutation>;
export type SaveSettingsMutationOptions = Apollo.BaseMutationOptions<SaveSettingsMutation, SaveSettingsMutationVariables>;
export const AllGroupSettingsDocument = gql`
    query AllGroupSettings($group: SetttingGroup!) {
  allGroupSettings(group: $group) {
    id
    group
    key
    value
    valueImage
  }
}
    `;

/**
 * __useAllGroupSettingsQuery__
 *
 * To run a query within a React component, call `useAllGroupSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGroupSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGroupSettingsQuery({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useAllGroupSettingsQuery(baseOptions: Apollo.QueryHookOptions<AllGroupSettingsQuery, AllGroupSettingsQueryVariables> & ({ variables: AllGroupSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllGroupSettingsQuery, AllGroupSettingsQueryVariables>(AllGroupSettingsDocument, options);
      }
export function useAllGroupSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGroupSettingsQuery, AllGroupSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllGroupSettingsQuery, AllGroupSettingsQueryVariables>(AllGroupSettingsDocument, options);
        }
export function useAllGroupSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllGroupSettingsQuery, AllGroupSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllGroupSettingsQuery, AllGroupSettingsQueryVariables>(AllGroupSettingsDocument, options);
        }
export type AllGroupSettingsQueryHookResult = ReturnType<typeof useAllGroupSettingsQuery>;
export type AllGroupSettingsLazyQueryHookResult = ReturnType<typeof useAllGroupSettingsLazyQuery>;
export type AllGroupSettingsSuspenseQueryHookResult = ReturnType<typeof useAllGroupSettingsSuspenseQuery>;
export type AllGroupSettingsQueryResult = Apollo.QueryResult<AllGroupSettingsQuery, AllGroupSettingsQueryVariables>;
export const CreateSignatureDocument = gql`
    mutation CreateSignature($input: CreateUpdateSignatureInput!) {
  createSignature(input: $input) {
    id
  }
}
    `;
export type CreateSignatureMutationFn = Apollo.MutationFunction<CreateSignatureMutation, CreateSignatureMutationVariables>;

/**
 * __useCreateSignatureMutation__
 *
 * To run a mutation, you first call `useCreateSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignatureMutation, { data, loading, error }] = useCreateSignatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSignatureMutation(baseOptions?: Apollo.MutationHookOptions<CreateSignatureMutation, CreateSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSignatureMutation, CreateSignatureMutationVariables>(CreateSignatureDocument, options);
      }
export type CreateSignatureMutationHookResult = ReturnType<typeof useCreateSignatureMutation>;
export type CreateSignatureMutationResult = Apollo.MutationResult<CreateSignatureMutation>;
export type CreateSignatureMutationOptions = Apollo.BaseMutationOptions<CreateSignatureMutation, CreateSignatureMutationVariables>;
export const UpdateSignatureDocument = gql`
    mutation UpdateSignature($id: ID!, $input: CreateUpdateSignatureInput!) {
  updateSignature(id: $id, input: $input) {
    id
    image
    imageUrl
    name
    enable
  }
}
    `;
export type UpdateSignatureMutationFn = Apollo.MutationFunction<UpdateSignatureMutation, UpdateSignatureMutationVariables>;

/**
 * __useUpdateSignatureMutation__
 *
 * To run a mutation, you first call `useUpdateSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignatureMutation, { data, loading, error }] = useUpdateSignatureMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSignatureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSignatureMutation, UpdateSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSignatureMutation, UpdateSignatureMutationVariables>(UpdateSignatureDocument, options);
      }
export type UpdateSignatureMutationHookResult = ReturnType<typeof useUpdateSignatureMutation>;
export type UpdateSignatureMutationResult = Apollo.MutationResult<UpdateSignatureMutation>;
export type UpdateSignatureMutationOptions = Apollo.BaseMutationOptions<UpdateSignatureMutation, UpdateSignatureMutationVariables>;
export const SetDefaultSignatureDocument = gql`
    mutation SetDefaultSignature($id: ID!) {
  setDefaultSignature(id: $id) {
    id
    isDefault
  }
}
    `;
export type SetDefaultSignatureMutationFn = Apollo.MutationFunction<SetDefaultSignatureMutation, SetDefaultSignatureMutationVariables>;

/**
 * __useSetDefaultSignatureMutation__
 *
 * To run a mutation, you first call `useSetDefaultSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultSignatureMutation, { data, loading, error }] = useSetDefaultSignatureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultSignatureMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultSignatureMutation, SetDefaultSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultSignatureMutation, SetDefaultSignatureMutationVariables>(SetDefaultSignatureDocument, options);
      }
export type SetDefaultSignatureMutationHookResult = ReturnType<typeof useSetDefaultSignatureMutation>;
export type SetDefaultSignatureMutationResult = Apollo.MutationResult<SetDefaultSignatureMutation>;
export type SetDefaultSignatureMutationOptions = Apollo.BaseMutationOptions<SetDefaultSignatureMutation, SetDefaultSignatureMutationVariables>;
export const DeleteSignatureDocument = gql`
    mutation DeleteSignature($id: ID!) {
  deleteSignature(id: $id) {
    id
  }
}
    `;
export type DeleteSignatureMutationFn = Apollo.MutationFunction<DeleteSignatureMutation, DeleteSignatureMutationVariables>;

/**
 * __useDeleteSignatureMutation__
 *
 * To run a mutation, you first call `useDeleteSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignatureMutation, { data, loading, error }] = useDeleteSignatureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSignatureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignatureMutation, DeleteSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignatureMutation, DeleteSignatureMutationVariables>(DeleteSignatureDocument, options);
      }
export type DeleteSignatureMutationHookResult = ReturnType<typeof useDeleteSignatureMutation>;
export type DeleteSignatureMutationResult = Apollo.MutationResult<DeleteSignatureMutation>;
export type DeleteSignatureMutationOptions = Apollo.BaseMutationOptions<DeleteSignatureMutation, DeleteSignatureMutationVariables>;
export const ListSignaturesDocument = gql`
    query ListSignatures($first: Int! = 10, $page: Int, $key: String, $enable: Boolean) {
  listSignatures(first: $first, page: $page, key: $key, enable: $enable) {
    paginatorInfo {
      ...CorePaginatorInfoFields
    }
    data {
      id
      image
      imageUrl
      name
      isDefault
      enable
    }
  }
}
    ${CorePaginatorInfoFieldsFragmentDoc}`;

/**
 * __useListSignaturesQuery__
 *
 * To run a query within a React component, call `useListSignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSignaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSignaturesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      key: // value for 'key'
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useListSignaturesQuery(baseOptions?: Apollo.QueryHookOptions<ListSignaturesQuery, ListSignaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSignaturesQuery, ListSignaturesQueryVariables>(ListSignaturesDocument, options);
      }
export function useListSignaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSignaturesQuery, ListSignaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSignaturesQuery, ListSignaturesQueryVariables>(ListSignaturesDocument, options);
        }
export function useListSignaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSignaturesQuery, ListSignaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSignaturesQuery, ListSignaturesQueryVariables>(ListSignaturesDocument, options);
        }
export type ListSignaturesQueryHookResult = ReturnType<typeof useListSignaturesQuery>;
export type ListSignaturesLazyQueryHookResult = ReturnType<typeof useListSignaturesLazyQuery>;
export type ListSignaturesSuspenseQueryHookResult = ReturnType<typeof useListSignaturesSuspenseQuery>;
export type ListSignaturesQueryResult = Apollo.QueryResult<ListSignaturesQuery, ListSignaturesQueryVariables>;
export const GetSignatureDocument = gql`
    query GetSignature($id: ID!) {
  getSignature(id: $id) {
    id
    image
    imageUrl
    name
    enable
  }
}
    `;

/**
 * __useGetSignatureQuery__
 *
 * To run a query within a React component, call `useGetSignatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignatureQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSignatureQuery(baseOptions: Apollo.QueryHookOptions<GetSignatureQuery, GetSignatureQueryVariables> & ({ variables: GetSignatureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignatureQuery, GetSignatureQueryVariables>(GetSignatureDocument, options);
      }
export function useGetSignatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignatureQuery, GetSignatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignatureQuery, GetSignatureQueryVariables>(GetSignatureDocument, options);
        }
export function useGetSignatureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSignatureQuery, GetSignatureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSignatureQuery, GetSignatureQueryVariables>(GetSignatureDocument, options);
        }
export type GetSignatureQueryHookResult = ReturnType<typeof useGetSignatureQuery>;
export type GetSignatureLazyQueryHookResult = ReturnType<typeof useGetSignatureLazyQuery>;
export type GetSignatureSuspenseQueryHookResult = ReturnType<typeof useGetSignatureSuspenseQuery>;
export type GetSignatureQueryResult = Apollo.QueryResult<GetSignatureQuery, GetSignatureQueryVariables>;
export const CreateSignatureBackgroundDocument = gql`
    mutation CreateSignatureBackground($input: CreateUpdateSignatureBackgroundInput!) {
  createSignatureBackground(input: $input) {
    id
  }
}
    `;
export type CreateSignatureBackgroundMutationFn = Apollo.MutationFunction<CreateSignatureBackgroundMutation, CreateSignatureBackgroundMutationVariables>;

/**
 * __useCreateSignatureBackgroundMutation__
 *
 * To run a mutation, you first call `useCreateSignatureBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignatureBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignatureBackgroundMutation, { data, loading, error }] = useCreateSignatureBackgroundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSignatureBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<CreateSignatureBackgroundMutation, CreateSignatureBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSignatureBackgroundMutation, CreateSignatureBackgroundMutationVariables>(CreateSignatureBackgroundDocument, options);
      }
export type CreateSignatureBackgroundMutationHookResult = ReturnType<typeof useCreateSignatureBackgroundMutation>;
export type CreateSignatureBackgroundMutationResult = Apollo.MutationResult<CreateSignatureBackgroundMutation>;
export type CreateSignatureBackgroundMutationOptions = Apollo.BaseMutationOptions<CreateSignatureBackgroundMutation, CreateSignatureBackgroundMutationVariables>;
export const UpdateSignatureBackgroundDocument = gql`
    mutation UpdateSignatureBackground($id: ID!, $input: CreateUpdateSignatureBackgroundInput!) {
  updateSignatureBackground(id: $id, input: $input) {
    id
    image
    imageUrl
    name
    enable
  }
}
    `;
export type UpdateSignatureBackgroundMutationFn = Apollo.MutationFunction<UpdateSignatureBackgroundMutation, UpdateSignatureBackgroundMutationVariables>;

/**
 * __useUpdateSignatureBackgroundMutation__
 *
 * To run a mutation, you first call `useUpdateSignatureBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignatureBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignatureBackgroundMutation, { data, loading, error }] = useUpdateSignatureBackgroundMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSignatureBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSignatureBackgroundMutation, UpdateSignatureBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSignatureBackgroundMutation, UpdateSignatureBackgroundMutationVariables>(UpdateSignatureBackgroundDocument, options);
      }
export type UpdateSignatureBackgroundMutationHookResult = ReturnType<typeof useUpdateSignatureBackgroundMutation>;
export type UpdateSignatureBackgroundMutationResult = Apollo.MutationResult<UpdateSignatureBackgroundMutation>;
export type UpdateSignatureBackgroundMutationOptions = Apollo.BaseMutationOptions<UpdateSignatureBackgroundMutation, UpdateSignatureBackgroundMutationVariables>;
export const SetDefaultSignatureBackgroundDocument = gql`
    mutation SetDefaultSignatureBackground($id: ID!) {
  setDefaultSignatureBackground(id: $id) {
    id
    isDefault
  }
}
    `;
export type SetDefaultSignatureBackgroundMutationFn = Apollo.MutationFunction<SetDefaultSignatureBackgroundMutation, SetDefaultSignatureBackgroundMutationVariables>;

/**
 * __useSetDefaultSignatureBackgroundMutation__
 *
 * To run a mutation, you first call `useSetDefaultSignatureBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultSignatureBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultSignatureBackgroundMutation, { data, loading, error }] = useSetDefaultSignatureBackgroundMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultSignatureBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultSignatureBackgroundMutation, SetDefaultSignatureBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultSignatureBackgroundMutation, SetDefaultSignatureBackgroundMutationVariables>(SetDefaultSignatureBackgroundDocument, options);
      }
export type SetDefaultSignatureBackgroundMutationHookResult = ReturnType<typeof useSetDefaultSignatureBackgroundMutation>;
export type SetDefaultSignatureBackgroundMutationResult = Apollo.MutationResult<SetDefaultSignatureBackgroundMutation>;
export type SetDefaultSignatureBackgroundMutationOptions = Apollo.BaseMutationOptions<SetDefaultSignatureBackgroundMutation, SetDefaultSignatureBackgroundMutationVariables>;
export const DeleteSignatureBackgroundDocument = gql`
    mutation DeleteSignatureBackground($id: ID!) {
  deleteSignatureBackground(id: $id) {
    id
  }
}
    `;
export type DeleteSignatureBackgroundMutationFn = Apollo.MutationFunction<DeleteSignatureBackgroundMutation, DeleteSignatureBackgroundMutationVariables>;

/**
 * __useDeleteSignatureBackgroundMutation__
 *
 * To run a mutation, you first call `useDeleteSignatureBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSignatureBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSignatureBackgroundMutation, { data, loading, error }] = useDeleteSignatureBackgroundMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSignatureBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSignatureBackgroundMutation, DeleteSignatureBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSignatureBackgroundMutation, DeleteSignatureBackgroundMutationVariables>(DeleteSignatureBackgroundDocument, options);
      }
export type DeleteSignatureBackgroundMutationHookResult = ReturnType<typeof useDeleteSignatureBackgroundMutation>;
export type DeleteSignatureBackgroundMutationResult = Apollo.MutationResult<DeleteSignatureBackgroundMutation>;
export type DeleteSignatureBackgroundMutationOptions = Apollo.BaseMutationOptions<DeleteSignatureBackgroundMutation, DeleteSignatureBackgroundMutationVariables>;
export const ListSignatureBackgroundsDocument = gql`
    query ListSignatureBackgrounds($first: Int! = 10, $page: Int, $key: String, $enable: Boolean) {
  listSignatureBackgrounds(first: $first, page: $page, key: $key, enable: $enable) {
    paginatorInfo {
      ...CorePaginatorInfoFields
    }
    data {
      id
      image
      imageUrl
      name
      isDefault
      enable
    }
  }
}
    ${CorePaginatorInfoFieldsFragmentDoc}`;

/**
 * __useListSignatureBackgroundsQuery__
 *
 * To run a query within a React component, call `useListSignatureBackgroundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSignatureBackgroundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSignatureBackgroundsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      key: // value for 'key'
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useListSignatureBackgroundsQuery(baseOptions?: Apollo.QueryHookOptions<ListSignatureBackgroundsQuery, ListSignatureBackgroundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSignatureBackgroundsQuery, ListSignatureBackgroundsQueryVariables>(ListSignatureBackgroundsDocument, options);
      }
export function useListSignatureBackgroundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSignatureBackgroundsQuery, ListSignatureBackgroundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSignatureBackgroundsQuery, ListSignatureBackgroundsQueryVariables>(ListSignatureBackgroundsDocument, options);
        }
export function useListSignatureBackgroundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSignatureBackgroundsQuery, ListSignatureBackgroundsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSignatureBackgroundsQuery, ListSignatureBackgroundsQueryVariables>(ListSignatureBackgroundsDocument, options);
        }
export type ListSignatureBackgroundsQueryHookResult = ReturnType<typeof useListSignatureBackgroundsQuery>;
export type ListSignatureBackgroundsLazyQueryHookResult = ReturnType<typeof useListSignatureBackgroundsLazyQuery>;
export type ListSignatureBackgroundsSuspenseQueryHookResult = ReturnType<typeof useListSignatureBackgroundsSuspenseQuery>;
export type ListSignatureBackgroundsQueryResult = Apollo.QueryResult<ListSignatureBackgroundsQuery, ListSignatureBackgroundsQueryVariables>;
export const GetSignatureBackgroundDocument = gql`
    query GetSignatureBackground($id: ID!) {
  getSignatureBackground(id: $id) {
    id
    image
    imageUrl
    name
    enable
  }
}
    `;

/**
 * __useGetSignatureBackgroundQuery__
 *
 * To run a query within a React component, call `useGetSignatureBackgroundQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignatureBackgroundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignatureBackgroundQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSignatureBackgroundQuery(baseOptions: Apollo.QueryHookOptions<GetSignatureBackgroundQuery, GetSignatureBackgroundQueryVariables> & ({ variables: GetSignatureBackgroundQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignatureBackgroundQuery, GetSignatureBackgroundQueryVariables>(GetSignatureBackgroundDocument, options);
      }
export function useGetSignatureBackgroundLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignatureBackgroundQuery, GetSignatureBackgroundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignatureBackgroundQuery, GetSignatureBackgroundQueryVariables>(GetSignatureBackgroundDocument, options);
        }
export function useGetSignatureBackgroundSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSignatureBackgroundQuery, GetSignatureBackgroundQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSignatureBackgroundQuery, GetSignatureBackgroundQueryVariables>(GetSignatureBackgroundDocument, options);
        }
export type GetSignatureBackgroundQueryHookResult = ReturnType<typeof useGetSignatureBackgroundQuery>;
export type GetSignatureBackgroundLazyQueryHookResult = ReturnType<typeof useGetSignatureBackgroundLazyQuery>;
export type GetSignatureBackgroundSuspenseQueryHookResult = ReturnType<typeof useGetSignatureBackgroundSuspenseQuery>;
export type GetSignatureBackgroundQueryResult = Apollo.QueryResult<GetSignatureBackgroundQuery, GetSignatureBackgroundQueryVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    id
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input) {
    id
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const ListUsersDocument = gql`
    query ListUsers($first: Int! = 10, $page: Int, $key: String) {
  listUsers(first: $first, page: $page, key: $key) {
    paginatorInfo {
      ...CorePaginatorInfoFields
    }
    data {
      id
      name
      email
    }
  }
}
    ${CorePaginatorInfoFieldsFragmentDoc}`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersSuspenseQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    name
    email
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;